export class UserAndBalance {
  user;
  balance;

  constructor(user, balance) {
    this.user = user;
    this.balance = balance;
  }
}
